import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { store } from 'redux/index';
import { getHomesHouseList } from 'redux/selectors';
import { setHouse } from 'redux/reducers';
import { UserList, SlideContainer } from 'components';
import { listSortOrganizationByName } from 'helpers';

function HomesListContainer({ basePath = '/homes', caseManager = false }) {
	const history = useHistory();
	const houseList = useSelector(getHomesHouseList);
	const sortedList = listSortOrganizationByName(houseList);

	const houseListMap = sortedList?.map((val) => {
		return { ...val, displayName: `${val.name}` };
	});

	const selectHome = async (e, { id }) => {
		const house = await houseList.filter((house) => house.id === id);
		await store.dispatch(setHouse(house));
		history.push(`${basePath}/manage/${id}`);
	};

	const addHouseToggle = () => {
		history.push(`${basePath}/manage`);
	};

	return (
		<SlideContainer>
			<UserList
				list={houseListMap}
				label='Households'
				pathParam={'houseId'}
				handleSelect={selectHome}
				addToggle={
					!caseManager || houseListMap.length === 0
						? addHouseToggle
						: undefined
				}
				addLabel='Add a Household'
			/>
		</SlideContainer>
	);
}

export default HomesListContainer;
